<template>
  <v-app>
    <router-view name="sidebar" />
    <router-view name="header" :handleSettingsDrawer="handleSettingsDrawer" />
    <v-main class="vuse-content">
      <v-fade-transition>
        <router-view />
      </v-fade-transition>
    </v-main>
    <router-view name="footer" />
    <app-settings-drawer
      :handleDrawer="handleSettingsDrawer"
      :drawer="settingsDrawer"
    />
  </v-app>
</template>

<script>
import AppSettingsDrawer from "@/layouts/App/AppSettingsDrawer";
/*
import Axios from "./services/axios";
import store from "./store";

//https://www.youtube.com/watch?v=nTJP2q2NIwM
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArt4-n00317yj1u6hNs1PKfj3n5mM_BRo",
  authDomain: "ibooknotifications.firebaseapp.com",
  projectId: "ibooknotifications",
  storageBucket: "ibooknotifications.appspot.com",
  messagingSenderId: "814633122882",
  appId: "1:814633122882:web:fd18fa6e35c751103301db",
  measurementId: "G-SDKX86SD7G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log(analytics);

// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
const messaging = getMessaging();
onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
  // ...
});


async function addDB (token)
{
  try{
      var customerId=null;
      if (!localStorage.getItem('customerId'))
      {
        const res = await Axios.post('/API/fcm/fcm.php', {"fcmToken":token,"hostname":window.location.hostname,"bindId":localStorage.getItem('bindId')});
        console.log(71,res);
        //localStorage.setItem('customerId',res.data.customerId)
        store.dispatch("setPushSubscribed",true);
        return true;
      }
      else
      {
        customerId=localStorage.getItem('customerId')
        const res = await Axios.post('/API/fcm/fcm.php', {"fcmToken":token,"customerId":customerId,"hostname":window.location.hostname,"bindId":localStorage.getItem('bindId')});
        console.log(79,res);
        return true;
      }      
  } catch(e)
  {
  console.log(e);
  }
}

getToken(messaging, { vapidKey: 'BN0j_Y-xwZu9f9jhq520_Kx1xYP4dP1rEvbUf-NLQmV2Gzo-TEmpe6U92sJoRtJppNJ7-lLQ_uAGxuwkWXd7Id4' }).then((currentToken) => {
  if (currentToken) {
    // Send the token to your server and update the UI if necessary
    // ...
    //localStorage.setItem('fcmToken',currentToken)
    addDB(currentToken);
    //console.log('91 App.vue',rsp)
  } else {
    // Show permission request UI
    console.log('No registration token available. Request permission to generate one.');
    // ...
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
  // ...
});
*/



export default {
  data: () => {
    return {
      settingsDrawer: false,
    };
  },
  components: {
    AppSettingsDrawer
  },
  methods: {
    handleSettingsDrawer() {
      this.settingsDrawer = !this.settingsDrawer;
    }
  },
};
</script>
